import React from 'react';

/**
 * Loading state component
 * Maps to Req 83 AC 2: loading states for every component
 * WCAG 2.1 AA compliant with aria-live
 */
interface LoadingStateProps {
  message?: string;
  size?: 'sm' | 'md' | 'lg';
}

export const LoadingState: React.FC<LoadingStateProps> = ({
  message = 'Loading...',
  size = 'md',
}) => {
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-8 w-8',
    lg: 'h-12 w-12',
  };

  return (
    <div
      className="flex flex-col items-center justify-center p-8"
      role="status"
      aria-live="polite"
      aria-label={message}
    >
      <div
        className={`${sizeClasses[size]} animate-spin rounded-full border-4 border-border border-t-primary-600`}
      />
      <p className="mt-4 text-sm text-muted-foreground">{message}</p>
    </div>
  );
};
